import { Button } from "@material-ui/core"
import { ButtonProps } from "@material-ui/core/Button"
import * as React from "react"

interface Props extends ButtonProps {
    fullRound: boolean
    children: React.ReactNode
    className: string
    href?: string
    style: React.CSSProperties
}

class BigButton extends React.Component<Props> {
    static defaultProps = {
        fullRound: true,
        className: "",
        style: {},
    }

    render() {
        const { style, fullRound, ...restProps } = this.props
        const height =
            this.props.style && this.props.style.height
                ? Number(String(this.props.style.height).replace(/\D+/g, ""))
                : 50

        return (
            <Button
                variant="contained"
                color="primary"
                size="large"
                style={{
                    borderRadius: fullRound ? "999px" : "10px",
                    height: height + "px",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    textTransform: "none",
                    fontSize: "1.15rem",
                    minWidth: "50px",
                    lineHeight: 1,
                    ...style,
                }}
                {...restProps}>
                {this.props.children}
            </Button>
        )
    }
}

export default BigButton
